var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountVerificationWarning',{on:{"verify-account":function($event){return _vm.verifyEmail(_vm.$root.contact)}}})}
var staticRenderFns = []

export { render, staticRenderFns }